import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../app/components/AppButton';
import { IconCalendar, IconPlusWhite } from '../../../../app/components/Icons';
import { lessonEditPath, rolePath } from '../../../../app/routes/paths';
import { useAppRole } from '../../../../app/routes/useRolePath';
import type { LessonOfferingDraft } from '../../application/types';
import { useCreateLessonOfferingMutation } from '../../infrastructure/api/lessonOfferings.api';
import { LessonCreateAside } from '../components/LessonCreateAside';
import { LessonForm } from '../components/LessonForm';
import { offeringPayload } from './offeringPayload';
import './lessons.scss';

const emptyDraft: LessonOfferingDraft = {
  title: '',
  durationMinutes: '60',
  price: '',
  currency: 'UAH',
};

export function LessonCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const role = useAppRole();
  const [draft, setDraft] = useState<LessonOfferingDraft>(emptyDraft);
  const [createOffering, { isLoading }] = useCreateLessonOfferingMutation();
  const payload = offeringPayload(draft);

  const onCreate = async () => {
    if (!payload) return;
    try {
      const created = await createOffering(payload).unwrap();
      if (!created?.id) return;
      navigate(rolePath(role, lessonEditPath(created.id)));
    } catch {
      // The mutation shows the error toast.
    }
  };

  return (
    <div className="mentor-lessons mentor-lessons--create">
      <header className="mentor-lessons__intro">
        <h1>
          <IconCalendar />
          {t('lesson.create_lesson')}
        </h1>
        <p>{t('lesson.create_lead')}</p>
      </header>
      <div className="mentor-lessons__create-layout">
        <LessonCreateAside />
        <section className="mentor-lessons__editor">
          <LessonForm value={draft} onChange={setDraft} />
          <div className="mentor-lessons__actions">
            <Button type="button" className="mentor-lessons__cancel" onClick={() => navigate(-1)}>
              {t('lesson.cancel')}
            </Button>
            <Button
              type="button"
              variant="primary"
              icon={<IconPlusWhite />}
              onClick={onCreate}
              disabled={!payload || isLoading}
            >
              {t('lesson.create_lesson')}
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default LessonCreatePage;
